/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { Theme } from '@mui/material/styles';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import { Paper, Popper } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars
const styles = (theme: Theme) => {
	return createStyles({
		icon: {
			color: 'rgba(0, 0, 0, 0.54)'
		},
		paperContainer: {
			backgroundColor: '#494B4F',
			color: 'white'
		}
	});
};

type Props = React.PropsWithChildren<object> & WithStyles<typeof styles>;

const HoverInfoTooltipView = (props: Props): JSX.Element => {
	const { classes } = props;
	const [anchorEl, setAnchorEl] = useState<SVGElement | null>(null);

	return (
		<>
			<InfoIcon
				className={classes.icon}
				onMouseEnter={(event): void => {
					setAnchorEl(event.currentTarget);
				}}
				onMouseLeave={(): void => setAnchorEl(null)}
			/>
			<Popper open={!!anchorEl} anchorEl={anchorEl} placement="bottom-start">
				<Paper elevation={8} className={classes.paperContainer}>
					{props.children}
				</Paper>
			</Popper>
		</>
	);
};

export default withStyles(styles)(HoverInfoTooltipView);
